import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface LoggerState {
  enabled: boolean;
}

// Define the initial state using that type
const initialState: LoggerState = {
  enabled: false
};

export const loggerSlice = createSlice({
  name: 'logger',
  initialState,
  reducers: {
    enableLogger: (state) => {
      state.enabled = true;
    },
    disableLogger: (state) => {
      state.enabled = false;
    }
  }
});

export const { enableLogger, disableLogger } = loggerSlice.actions;

/* @ts-ignore */
export const selectLogger = ({ logger }) => {
  return logger.enabled;
};

export default loggerSlice.reducer;
